import { EmptyStateProps } from 'owa-empty-state/lib/components/EmptyState';
import {
    agendaPaneEmptyStatePrimaryText,
    agendaPaneEmptyStateSecondaryText,
    multidayAgendaPaneEmptyStatePrimaryText,
} from './getEmptyStateProps.locstring.json';
import { getIsLightBaseTheme } from 'owa-theme';
import loc, { format } from 'owa-localize';
import { differenceInDays, formatMonthDayYear } from 'owa-datetime';
import { DateRange } from 'owa-datetime-utils';

/**
 * initialize the svgs icons
 */
let EMPTY_STATE;

function initializeDisplayIconsForEmptyList() {
    if (getIsLightBaseTheme()) {
        // colored svgs that goes with the blue base theme
        EMPTY_STATE = require('owa-empty-state/lib/svg/colored/balloon.svg');
    } else {
        // gray scale svgs
        EMPTY_STATE = require('owa-empty-state/lib/svg/gray/balloon.svg');
    }
}

export function getEmptyStateProps(dateRange: DateRange): EmptyStateProps {
    initializeDisplayIconsForEmptyList();

    let primaryTextEmpty = '';
    // VSO 56737 Revert check once root cause of null dateRange is understood and fixed
    if (dateRange) {
        const { start, end } = dateRange;
        primaryTextEmpty =
            differenceInDays(end, start) <= 1
                ? loc(agendaPaneEmptyStatePrimaryText)
                : format(
                      loc(multidayAgendaPaneEmptyStatePrimaryText),
                      formatMonthDayYear(start),
                      formatMonthDayYear(end)
                  );
    }
    return {
        icon: EMPTY_STATE,
        detailMessage: loc(agendaPaneEmptyStateSecondaryText),
        mainMessage: primaryTextEmpty,
    };
}
